import { Factory } from '../Factory';

namespace app.services.messaging {
  import IIntervalService = angular.IIntervalService;

  export class WebSocketService {
    private isConnected: boolean;

    private readonly accountSubscription: any[];
    private readonly projectSubscriptions: any[];
    private readonly roleSubscriptions: any[];

    constructor(private rootScope: IRootScope, private intervalService: IIntervalService, private stomp: any, private tokenService: app.services.authentication.TokenService, private configService: app.services.IConfigService, private stateService: app.services.state.StateService, private notificationService: app.services.INotificationService) {
      this.accountSubscription = [];
      this.projectSubscriptions = [];
      this.roleSubscriptions = [];
      this.isConnected = false;

      rootScope.$on(EVENTS.LOGIN_REQUIRED, () => this.UnSubscribeFromAll());
      rootScope.$on(EVENTS.LOGIN_CONFIRMED, () => this.ConnectAndSubscribeToAccount());
      rootScope.$on("ProjectService.CurrentProjectChanged", (event, project) => this.SubscribeToProject(project));
    }

    public ConnectAndSubscribeToAccount() {
      console.log("Subscribing...");

      this.connect().then(_ => {
        this.SubscribeToAccount();
      });

    }

    public SubscribeToAccount() {
      this.waitForConnection().then(_ => {
        WebSocketService.unsubscribeFromGroup(this.accountSubscription);
        this.accountSubscription.push(
          this.stomp.subscribe("/user/exchange/amq.direct/message",
            (payload, headers, res) => this.handleMessage(payload, headers, res))
        );
      });
    }

    // TODO: Race condition to connect?
    public SubscribeToProject(project) {
      if (project) {
        this.waitForConnection().then(() => {

          console.log("Subscribing to project", {id: project?.id, name: project?.name});
          WebSocketService.unsubscribeFromGroup(this.projectSubscriptions);
          this.projectSubscriptions.push(
            this.stomp.subscribe("/topic/project." + project.id,
              (payload, headers, res) => this.handleMessage(payload, headers, res))
          );

          // I know this does a foreach, but you really only get one role from a project.
          project.roles.forEach((role) => {
            this.SubscribeToRole(role);
          })

        });
      } else {
        WebSocketService.unsubscribeFromGroup(this.projectSubscriptions);
        WebSocketService.unsubscribeFromGroup(this.roleSubscriptions);
      }
    }

    public SubscribeToRole(role) {
      if (role) {
        this.waitForConnection().then(() => {

          console.log("Subscribing to role", role);
          WebSocketService.unsubscribeFromGroup(this.roleSubscriptions);
          this.roleSubscriptions.push(
            this.stomp.subscribe("/topic/role." + role.id,
              (payload, headers, res) => this.handleMessage(payload, headers, res))
          );

        });
      }
    }

    public UnSubscribeFromAll() {
      console.log("Unsubscribing...");
      if (this.isConnected) {
        WebSocketService.unsubscribeFromGroup(this.accountSubscription);
        WebSocketService.unsubscribeFromGroup(this.projectSubscriptions);
        WebSocketService.unsubscribeFromGroup(this.roleSubscriptions);

        this.isConnected = false;

        this.stomp.disconnect().then(() => {
          console.log("Disconnected");
        });
      }
    }

    private handleMessage(payload, headers, res) {
      this.rootScope.$apply(() => {
        if (payload.type === 'notification') {
          this.notificationService.addCurrentMessage(payload.message);
        } else {
          let event = 'FeedService.' + payload.type;
          this.rootScope.$broadcast(event, payload.message);
        }
      });
    };

    private async connect() {
      const token = this.tokenService.GetAccessToken();

      const wsHttpUrl =
        `${this.configService.getServerBaseUrl()}/websocket?access_token=${token}`;

      try {
        const state = await this.stomp.connect(wsHttpUrl, {
          'client-id': this.configService.getClientId()
        });

        this.isConnected = true;
        return state;
      } catch (e) {
        this.isConnected = false;
        throw e;
      }
    }

    private async waitForConnection() {
      return new Promise((resolve => {
        const stop = this.intervalService(() => {
          if (this.isConnected) {
            this.intervalService.cancel(stop);
            resolve(true);
          }
        }, 300);
      }));
    }

    private static unsubscribeFromGroup(group) {
      group.forEach((sub) => {
        sub.unsubscribe();
      });
      group.length = 0;
    }

  }

  frontendApp.factory("WebSocketService", ["$rootScope", "$interval", "$stomp", "TokenService", "ConfigService", "StateService", "NotificationService", Factory.Create(WebSocketService)]);
}
